import { LocalizedText, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, Dialog } from '@optimus-web/core';
import { useRatesDelete } from '../../../mutations';

interface DeleteRateDialogProps {
    rateIds: string[];
    onDeleteSuccess?: () => void;
    onClose: () => void;
    active: boolean;
}

export const DeleteRatesDialog = ({ rateIds, onDeleteSuccess, onClose, active }: DeleteRateDialogProps) => {
    const { mutate, isPending } = useRatesDelete();

    const handleConfirm = () =>
        mutate(
            { rateIds },
            {
                onSettled: () => onClose(),
                onSuccess: () => {
                    onDeleteSuccess?.();
                },
            }
        );

    const footer = {
        primary: (
            <Button variant="destructive" onClick={handleConfirm} type="submit">
                {lt('Delete')}
            </Button>
        ),
        secondary: (
            <Button variant="tertiary" onClick={onClose} type="submit">
                {lt('Cancel')}
            </Button>
        ),
    };

    return (
        <Dialog
            title={
                <LocalizedText
                    textKey={TextKey.RateGroupRateDeleteDialogTitle}
                    substitutes={{ count: rateIds.length }}
                />
            }
            footer={footer}
            active={active}
            loading={isPending}
            onClose={onClose}
        >
            <LocalizedText
                textKey={TextKey.RateGroupRateDeleteDialogDescription}
                substitutes={{ count: rateIds.length }}
            />
        </Dialog>
    );
};
